export default __webpack_public_path__ + "static/O0042-fb04e11216bef0dd85822a9bff0a72dd.png";